import { AddressBookRowActions } from 'modules/crm/address-book/components/AddressBookRowActions';
import { CellType, HeadCell } from '@dfl/mui-admin-layout';
import { IAddressBook } from 'modules/crm/address-book/interfaces';
import { addressColumn, createdATColumn } from 'modules/common/constants/common.columns';
import { ADDRESS_BOOK_PERMISSIONS } from 'modules/crm/address-book/constants/address-book.permissions';
import { AvatarNameCell } from 'modules/common/components/AvatarNameCell';
import { getFullName } from 'utils/index';
import { IClients } from 'modules/crm/clients/interfaces';
import { ADDRESS_BOOK_ROUTER } from './address-book.route';

export const addressBookNameColumn: HeadCell<IAddressBook> = {
  field: 'person',
  headerName: 'clients:fields.name',
  disablePadding: false,
  renderCell: (person: IClients, data: IAddressBook) => (
    <AvatarNameCell
      link={ADDRESS_BOOK_ROUTER.DETAIL(data?._id as string)}
      name={getFullName(person?.firstName, person?.lastName)}
      secondary={person?.email}
      hideImage
    />
  ),
};

export const addressBookActionsColumn: HeadCell<IAddressBook> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: ADDRESS_BOOK_PERMISSIONS.ADDRESS_BOOK_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  component: AddressBookRowActions,
};

export const phoneColumn: HeadCell = {
  field: 'person.phone',
  type: CellType.PHONE,
  headerName: 'common:phone',
};
export const emailColumn: HeadCell = {
  field: 'person.email',
  type: CellType.EMAIL,
  headerName: 'common:email',
};

export const addressBookColumns: Array<HeadCell<any>> = [
  addressBookNameColumn,
  addressColumn,
  phoneColumn,
  emailColumn,
  createdATColumn,
  addressBookActionsColumn,
];
